module.exports = __webpack_public_path__ + "img/[旺柴].234c75f9.svg";